import React from 'react'

export default function Term(props) {

  return (
   <>
    <span>{props.termName}</span>
   </>
  )
}
